(ns dre.modals.search.share.views
  (:require
   ["antd" :refer [Spin]]
   [dre.components.select :refer [select]]
   [dre.components.inputs :refer [input-text]]
   [dre.components.form :refer [form form-item]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.modals.search.share.events :as events]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn- share-content
  []
  (let [component-name :search-share
        data @(rf/subscribe [::events/state])
        entities (:entities data)
        state (:state data)
        loading? (= state :loading)
        entities-grouped (group-by :type entities)
        optgroups [{:label "All persons at division" :options (get entities-grouped "division")}
                   {:label "All persons in team" :options (get entities-grouped "team")}
                   {:label "All persons at client" :options (get entities-grouped "client")}
                   {:label "Individual persons" :options (get entities-grouped "user")}]
        optgroups (remove #(nil? (:options %)) optgroups)]
    [:div
     {:class [component-name]
      :style {:width "100%"}}
     [form
      {:layout "vertical"}
      [:<>
       [form-item
        {:label [tr "Your message"]}
        [input-text
         {:on-change #(rf/dispatch [::events/update-data [:share-msg] (-> % .-target .-value)])
          :value (:share-msg data)}]]
       [form-item
        {:label [tr "Share with (type 3 or more characters)"]}
        [select
         {:mode "multiple"
          :filterOption false
          :showSearch true
          :value (:selected-entities data)
          :onChange #(rf/dispatch [::events/update-data [:selected-entities] %])
          :onSearch (fn [e] (rf/dispatch [::events/get-entities e]))
          :placeholder [tr "Search available persons and clients"]
          :options (if loading? [] optgroups)
          :notFoundContent (when loading? (r/as-element [:> Spin]))}]]]]]))

(defn share-view
  []
  (let [data @(rf/subscribe [::events/state])]
    [modal-window
     {:title "Share your search"
      :content share-content
      :submit? true
      :submit-text [tr "Share"]
      :submit-disabled? (when (or (not (seq (:selected-entities data))) (empty? (:share-msg data)))
                          true)
      :on-submit #(rf/dispatch [::events/share-query])}]))
